import { useEffect, useState } from 'react';
import './Notifications.css';
import NotificationItem from '../NotificationItem/NotificationItem';
import { updateNotification } from '../../utilities/api/users';

export default function Notifications({ user, updateUser, handleDropdownClick }) {
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    const markAsRead = async (notificationID) => {
        const updatedUser = await updateNotification(user._id, notificationID)
        if (updatedUser) {
            updateUser(updatedUser);
            setNotifications(updatedUser.notifications.filter(notification => notification.software === 'docket').sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
            const unreadNotifications = updatedUser.notifications.filter(notification => !notification.read);
            setUnreadCount(unreadNotifications.length);
        }
    }

    useEffect(() => {
        if (user && user.notifications) {
            const docketNotifications = user.notifications.filter(notification => notification.software === 'docket');
            setNotifications(docketNotifications.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
            const unreadNotifications = docketNotifications.filter(notification => !notification.read);
            setUnreadCount(unreadNotifications.length);
        }
    }, [user]);

  return (
    <div className='Notifications dropdown notificationsDropDown navItem'>
        <div className='notificationsDropDownToggle' id='notificationsDropDownToggle' title='Notifications' data-title='Notifications' data-bs-toggle="dropdown" aria-expanded="false">
            <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <mask id="mask0_170_1767" style={{"maskType":"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="29" height="29">
                <rect x="9.74316" y="0.792969" width="21" height="21" transform="rotate(25.2218 9.74316 0.792969)" fill="url(#pattern0_170_1767)"/>
                </mask>
                <g mask="url(#mask0_170_1767)">
                <rect x="10.0405" y="-4.16992" width="24.9231" height="28.6154" transform="rotate(25.2218 10.0405 -4.16992)" fill="#1B2B41" fillOpacity="0.69"/>
                </g>
                <defs>
                <pattern id="pattern0_170_1767" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_170_1767" transform="scale(0.02)"/>
                </pattern>
                <image id="image0_170_1767" width="50" height="50" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZUlEQVR4nO2az2sTQRiGHxCNCopKD9amioJUPNiLVo+2B1HBo3gUQVDEgoj+C9qLXiyePQiChOrJv6CUHloUlaogHqpYf1QxlaJY68gHXyCEZLNJ8307K77wQnZ2Z+Z9dmd2N5OAnXqBErCgHgP6yJl6gS9AqLGUFcmRSnUgKr5PjrSQAFLmHwH5Ro40lgAiwy5arQOuACO63Zcw2XfrMSNaR+pGoX7ghQb9DezX8qJO7LK6VAVxQI8NWlfayFRDwGLNWZ/XoI00UOdqSRuDZKT+OhAVLwF3gIPAevUhLVtqUEfa2ucNsRaYSZjQ7XpG23bTVQOIii97QawGPhmCfNQ+zHXCECKoj3uAjDqA3PIAmXQAmfAA+eAA8t4D5KcDyA9riDUOEEFteufa4giyyRJkuyNIjyXIXkeQPZYgxxxBjliCXHIEGbYEue0IMmoJ8twR5IkVRNERIgB/gG15nx/Bap6sAl5nAPJG++6YzmQAEdSnOwUhT9ivGYLMA90rhdgIPM4QIqingA3tQuwCnkUAEdRPgZ2tQhzWSxoi82fNlkqngF8RhA4NLNlOpgF5F0HY0MRv04CUIwgamjjVbyz3IggamvhuGhB5v3kVQdjQwC+BraSUrJ7fTFhtz8KLwA3N1tYD8SzwEJjLIPwc8EAzSJaOaQdwFDgPXNex+ggY14fnrL7OVLxcFWq5Zt+s1hnXNqSta8A57UP6+q+VSl5ruoDN6kLVvkJVeZceG62+tzD+o/7jwGRsK+7targFkAtErELK7y/TuiAetXqawExbrY5gIDnbF3UeyA1ALJ9lOJlcib/w6kqRL7T5PwAAAABJRU5ErkJggg=="/>
                </defs>
            </svg>
            { unreadCount > 0 &&
            <div className='notificationCount'>
                {unreadCount}
            </div>
            }
        </div>
        <div className='dropdown-menu notificationsDropDown text-center' aria-labelledby="notificationsDropDownToggle" onClick={handleDropdownClick}>
            <div className='header'>
                Notifications <small className='instruction'>(Click to mark as read)</small>
            </div>
            {notifications.length === 0 ?
            <div className='noNotifications'>
                No Notifications
            </div>
            :
            <div className='notificationsList'>
            {notifications.map((notification, index) => (
                <NotificationItem key={index} notification={notification} markAsRead={markAsRead} />
            ))}
            </div>
            }
        </div>
    </div>
  )
}
